import useMarketSelectorDisplayedMarkets from 'src/components/MarketSelector/hooks/useMarketSelectorDisplayedMarkets';
import useMarketSelectorState from 'src/components/MarketSelector/hooks/useMarketSelectorState';
import useIsMobileScreenSize from 'src/hooks/useIsMobileScreenSize';

export default function useMarketSelectorDropdown() {
	const isMobileScreenSize = useIsMobileScreenSize();

	const {
		searchValue,
		setSearchValue,
		selectedCategory,
		setSelectedCategory,
		sort,
		toggleSort,
		isFavoritesSticky,
		toggleIsFavoritesSticky,
	} = useMarketSelectorState();

	const displayedMarkets = useMarketSelectorDisplayedMarkets({
		selectedCategory,
		searchValue,
		sort,
		isFavoritesSticky,
	});

	return {
		displayedMarkets,
		searchValue,
		setSearchValue,
		selectedCategory,
		setSelectedCategory,
		sort,
		toggleSort,
		isMobileScreenSize,
		isFavoritesSticky,
		toggleIsFavoritesSticky,
	};
}
